<template>
  <div id="app">
    <Loading v-if="loading.isShow" :type="loading.showType"/>
    <router-view />
  </div>
</template>

<script>
import {store} from '@/config/store'
import Loading from './components/Loading'
export default {
  name: 'App',
  components: {
    Loading
  },
  data() {
    return {
      store
    }
  },
  computed: {
    loading(){
      return this.store.loading
    }
  }
}
</script>

<style>
body {
  font-size: 16px;
  /* background-color: #f8f8f8; */
  -webkit-font-smoothing: antialiased;
}
</style>
